export enum ThemeUrls {
  IMMOMIO = 'immomio'
}
